import "../../assets/index24.css";
import { jsx as s } from "react/jsx-runtime";
import { I as f } from "../../chunks/index.3a885b6a.js";
import { m as _ } from "../../chunks/make-refs.cb0b9b76.js";
import { forwardRef as b } from "react";
import { c as i } from "../../chunks/index.80e735c1.js";
const I = "_buttonIcon_o8i2p_1", g = "_black_o8i2p_34", d = "_ghost_o8i2p_43", h = "_small_o8i2p_51", c = {
  buttonIcon: I,
  black: g,
  ghost: d,
  small: h
}, k = ({
  className: n,
  size: o,
  variant: t
}) => i(c.buttonIcon, n, {
  [c[o]]: o !== "large",
  [c[t]]: t !== "default"
}), w = b(
  ({
    className: n,
    icon: o,
    isDecorative: t = !1,
    size: e = "large",
    variant: a = "default",
    ...m
  }, p) => {
    const { $el: u } = _(p, ["$el"]), r = {
      className: k({
        className: n,
        size: e,
        variant: a
      }),
      ref: u,
      ...m
    }, l = /* @__PURE__ */ s(f, { icon: o });
    return t ? /* @__PURE__ */ s(
      "span",
      {
        role: "figure",
        ...r,
        children: l
      }
    ) : /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        ...r,
        children: l
      }
    );
  }
);
export {
  w as ButtonIcon
};
//# sourceMappingURL=index.js.map
